import { Box, Typography } from '@mui/material';
import { useQuery, gql } from 'urql';

import { useUser } from '@/components/auth-provider';
import EditUserForm from '../../user/EditUserForm';
import ErrorBanner from '../../banners/ErrorBanner';

const CURRENT_USER_QUERY = gql`
  query getUser($id: Int!) {
    userDetails(id: $id) {
      companiesId
      email
      id
      name
      phone
    }
  }
`;

export default function EditAccount() {
  const { user } = useUser();
  const [{ data, error }] = useQuery({
    pause: !user,
    query: CURRENT_USER_QUERY,
    variables: {
      id: Number(user?.id),
    },
  });

  if (error) {
    return (
      <Box>
        <ErrorBanner>
          <Typography variant="body2" color="error">
            Something happened, try refreshing the page. If the issue persists,
            contact our support email for help.
          </Typography>
        </ErrorBanner>
      </Box>
    );
  }

  if (!data) return null;

  return <EditUserForm user={data.userDetails} />;
}
